/* src/app/components/image-modal/image-modal.component.scss */
img {
  border-radius: 15px;
}
button {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 100;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  min-height: 0;
  padding: 5px;
}
button ion-icon {
  width: 32px;
  height: 32px;
  color: black;
}
button:hover {
  opacity: 0.7;
}
/*# sourceMappingURL=image-modal.component-JQ35HVP4.css.map */
